import { apiClient } from '../client'
import type { ApiSuccessResponse } from '../../types/api'
import type { CaseOutcomePayload, CaseOutcomeUpdatePayload } from '../../types/outcome'

export const outcomeService = {
  async show(caseId: string) {
    const { data } = await apiClient.get<ApiSuccessResponse<CaseOutcomePayload>>(
      `/cases/${caseId}/outcome`,
    )
    return data
  },

  async update(caseId: string, payload: CaseOutcomeUpdatePayload) {
    const { data } = await apiClient.put<ApiSuccessResponse<CaseOutcomePayload>>(
      `/cases/${caseId}/outcome`,
      payload,
    )
    return data
  },
}
